import { ThemeBrightnessEnum } from '@src/app/modules/theme-switcher/types';
import { StorageKeys } from '@src/constants/storage';

const root = document.documentElement;
const theme = localStorage.getItem(StorageKeys.Theme);

// INFO: имя переменной брать из файла src/styles/global.scss
const unionsBGColorVariableName = '--unions-color-background';

// INFO: цвета брать из переменной --unions-color-background в файле src/styles/global.scss
const bgColor = theme === ThemeBrightnessEnum.Dark ? '#000000' : '#fbfbfb';

export const setHackTheme = () => {
  if (root && root.style && root.style) {
    root.style.setProperty(unionsBGColorVariableName, bgColor);
  }
};

export const removeHackTheme = () => {
  if (root && root.style && root.style) {
    root.style.removeProperty(unionsBGColorVariableName);
  }
};
